import React from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux'
import RssFeedCRUDActions from "@mm/state/actions/RssFeedCRUDActions";
import Switch from '../../../../../common/components/Switch/Switch';
import './RssFeedDetails.scss';

const ActiveToggle = ({ feed, onToggle, errors, disabled }) => (
  <div>
    <span className="feed-details__toggle-draft">Draft</span>
    <Switch checked={feed.active} onChange={onToggle} disabled={disabled} />
    <span className="feed-details__toggle-active">Active</span>
    <div className="feed-details__error">{ errors.toggle }</div>
  </div>
);

const onToggle = ({ chatbotId, feed, updateFeed, isValid }) => () => {
  const updatedFeed = Object.assign({}, feed, { active: !feed.active });
  if (updatedFeed.active) {
    if (isValid(updatedFeed)) {
      updateFeed(chatbotId, updatedFeed);
    }
  } else {
    updateFeed(chatbotId, updatedFeed);
  }
}

const mapDispatchToProps = dispatch => ({
  updateFeed: (botId, entity) => dispatch(RssFeedCRUDActions.update(botId, entity)),
});

const enhance = compose(
  connect(null, mapDispatchToProps),
  withHandlers({ onToggle }),
);

export default enhance(ActiveToggle);
